export type FormSkeletonStyle = Partial<{
  blockClassName: string
  headerClassName: string
  subHeaderClassName: string
  innerClassName: string
  titleClassName: string
  subTitleClassName: string
  introClassName: string
  formClassName: string
  formInnerClassName: string
  formAlertClassName: string
  formAlertErrorClassName: string
  formAlertWarningClassName: string
  formAlertSuccessClassName: string
  formAlertInfoClassName: string
  formGroupClassName: string
  formGroupInputClassName: string
  formGroupSelectClassName: string
  formGroupSwitchClassName: string
  formGroupFocusedClassName: string
  formGroupCheckboxClassName: string
  formGroupRadioClassName: string
  formBooleanLabelClassName: string
  formBooleanInputClassName: string
  formBooleanErrorClassName: string
  formInputClassName: string
  formSelectClassName: string
  formDataListClassName: string
  formLabelClassName: string
  formFieldErrorClassName: string
  formFieldFeedbackInvalidClassName: string
  formFieldFeedbackClassName: string
  formActionsClassName: string
  clickableWrapperClassName: string
  clickablePrimaryClassName: string
  clickableSecondaryClassName: string
  clickableTertiaryClassName: string
  footerClassName: string
  footerItemClassName: string
}>

export const formSkeletonClasses: FormSkeletonStyle = {
  blockClassName: 'form-skeleton fs',
  headerClassName: 'fs__header',
  subHeaderClassName: 'fs__subheader',
  titleClassName: "fs__title title--s",
  subTitleClassName: "fs__subtitle title--xs",
  introClassName: 'fs__intro text--styled',
  formClassName: 'fs__form',
  formInnerClassName: 'fs__form-inner',
  formAlertClassName: "fs__alert text--styled text--s",
  formAlertErrorClassName: 'fs__alert--error',
  formAlertWarningClassName: 'fs__alert--warning',
  formAlertSuccessClassName: 'fs__alert--success',
  formAlertInfoClassName: 'fs__alert--info',
  formGroupClassName: 'fs__group',
  formGroupInputClassName: 'fs__group--input',
  formGroupSelectClassName: 'fs__group--select',
  formGroupSwitchClassName: 'fs__group--switch',
  formGroupCheckboxClassName: 'fs__group--checkbox',
  formGroupRadioClassName: 'fs__group--radio',
  formGroupFocusedClassName: 'fs--focused',
  formLabelClassName: 'fs__label',
  formInputClassName: 'fs__input',
  formSelectClassName: 'fs__select',
  formDataListClassName: 'fs__datalist',
  formBooleanInputClassName: '',
  formBooleanLabelClassName: "text--styled text--s",
  formFieldErrorClassName: 'fs__invalid is-invalid',
  formFieldFeedbackInvalidClassName: 'fs__error',
  formFieldFeedbackClassName: 'fs__description',
  formActionsClassName: 'fs__actions',
  clickableWrapperClassName: 'fs__action',
  clickablePrimaryClassName: "button button--primary",
  clickableSecondaryClassName: "button button--secondary",
  clickableTertiaryClassName: "button button--tertiary",
  footerClassName: "fs__options text--styled",
  footerItemClassName: "fs__option",
}
